import { RouteObject } from 'react-router';
import { ResultRequestFeature } from '@vivli/features/results-request/feature';
import { PlatformInitWrapper } from '@vivli/core/infrastructure/wrappers';

export const useResultRequestRoutes = (): RouteObject[] => {
    return [
        {
            element: <PlatformInitWrapper />,
            children: [
                {
                    path: '/',
                    element: <ResultRequestFeature />
                }
            ]
        }
    ];
};
